<template>
    <div class="badges">
        <div :id="`badges__list--${uid}`" class="badges__list">
            <common-badge
                v-for="(badge, index) in badges"
                :key="index"
                class="badges__list--item"
                :title="badge.label"
                :value="badge"
                :icon="icon"
                @emitEvent="emitEvent($event)"
            ></common-badge>
        </div>
        <div v-if="moreCount > 0" class="badges__more">+ {{ moreCount }}</div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'

    export default {
        props: {
            badges: { type: Array, required: true },
            icon: { type: String, default: 'close' },
        },

        data() {
            return {
                badgesRef: [],
                moreCount: 0,
                uid: uuidv4(),
            }
        },

        methods: {
            recalculateMore() {
                this.$nextTick(() => {
                    const allBadges = document.querySelectorAll(`#badges__list--${this.uid} .badges__list--item`)

                    const unvisibleBadges = []

                    if (!allBadges.length) {
                        return
                    }

                    for (const badge of allBadges) {
                        if (badge.offsetTop > 12) {
                            unvisibleBadges.push(badge)
                        }
                    }

                    this.moreCount = unvisibleBadges.length
                })
            },
        },

        watch: {
            badges() {
                this.recalculateMore()
            },

            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.recalculateMore()
                }
            },
        },

        mounted() {
            this.recalculateMore()
        },

        created() {
            window.addEventListener('resize', this.recalculateMore)
        },

        destroyed() {
            window.removeEventListener('resize', this.recalculateMore)
        },
    }
</script>
